import React from 'react';
import Hero from '../components/Hero';

const BarberiaHome = () => {
  return (
    <div className="barberia-home">
      <Hero />
    </div>
  );
};

export default BarberiaHome;
